var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 52 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeWidth: 0.3,
    d: "M4.318 47.278V4.708l41.957 21.169L4.318 47.278zM1 2.324V49.72c0 .698.737 1.28 1.697 1.28.368 0 .737-.116 1.031-.29l46.529-23.728c.737-.407.959-1.222.516-1.803-.148-.175-.369-.35-.59-.407L3.507 1.219c-.737-.407-1.77-.233-2.285.407C1.074 1.8 1 2.09 1 2.324h0z",
    opacity: 0.82
  })));
}
export default SvgPlay;